import React, { useEffect, useState } from 'react'

import { Image } from '@application/Interfaces/Atoms/Image'
import { getSpeedTimeInMilliSecond, handleThumbClick } from '@application/Interfaces/Features/ImageSlider/utils'
import { ImageSliderType } from '@application/Types/ComponentTypes'

import { CarouselWrapper, ImageThumbnails, ImageWrapper, Text, Thumb, TitleSection } from './ImageSlider.styled'

export const ImageSlider = ({ title, subtitle, theme, images, autoplay, speed }: ImageSliderType): JSX.Element => {
    const [active, setActive] = useState(0)
    const [intervalId, setIntervalId] = useState<NodeJS.Timer>()
    const slideAutoSpeed = getSpeedTimeInMilliSecond(speed ?? undefined)

    useEffect(() => {
        handleThumbClick({
            intervalTime: slideAutoSpeed,
            setActive,
            index: 0,
            intervalId,
            setIntervalId,
            maxlength: images.length - 1,
            autoplay,
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        return () => {
            intervalId && clearInterval(intervalId)
        }
    }, [intervalId])

    return (
        <TitleSection title={title} subtitle={subtitle} mode={theme}>
            <CarouselWrapper>
                <ImageWrapper>
                    <Image image={images[active].image} />
                </ImageWrapper>
                <ImageThumbnails>
                    {images.map((item, index) => (
                        <Thumb
                            key={item.title}
                            $active={index === active}
                            $completed={index < active && autoplay}
                            $speed={slideAutoSpeed}
                            $autoplay={autoplay}
                            className={index === active ? 'active' : ''}
                            data-testid={`title-${index}`}
                            onClick={handleThumbClick({
                                intervalTime: slideAutoSpeed,
                                setActive,
                                index,
                                intervalId,
                                setIntervalId,
                                maxlength: images.length - 1,
                                autoplay,
                            })}
                        >
                            <Text>{item.title}</Text>
                        </Thumb>
                    ))}
                </ImageThumbnails>
            </CarouselWrapper>
        </TitleSection>
    )
}
